import './PageLayout.css';

import React, { ReactNode } from 'react';

export const PageContentWrapper = (props: { children?: ReactNode }) => {
  return <div className="page-content-wrapper">{props.children}</div>;
};

export const PageWrapper = (props: {
  children?: ReactNode;
  headerCollapsed?: boolean;
}) => {
  return (
    <div
      className={`page-wrapper ${
        props.headerCollapsed ? 'header-collapsed' : ''
      }`}
    >
      {props.children}
    </div>
  );
};

export const PageHeaderWrapper = (props: { children?: ReactNode }) => {
  return <div className="page-header-wrapper">{props.children}</div>;
};
